
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexKUTFagQbguMeta } from "/builds/1tool/leckorter-portal/pages/appointments/index.vue?macro=true";
import { default as dashboardTZBkp2J2ZRMeta } from "/builds/1tool/leckorter-portal/pages/dashboard.vue?macro=true";
import { default as indexbBeX8yQlShMeta } from "/builds/1tool/leckorter-portal/pages/index.vue?macro=true";
import { default as indexifM9Qjbq9GMeta } from "/builds/1tool/leckorter-portal/pages/invoices/index.vue?macro=true";
import { default as forgot_45passwordEUFjyHtc1xMeta } from "/builds/1tool/leckorter-portal/pages/login/forgot-password.vue?macro=true";
import { default as indexyQzNj8i3d3Meta } from "/builds/1tool/leckorter-portal/pages/login/index.vue?macro=true";
import { default as magic_45linkoajBhhxVj5Meta } from "/builds/1tool/leckorter-portal/pages/login/magic-link.vue?macro=true";
import { default as indexSqgFyJJxXIMeta } from "/builds/1tool/leckorter-portal/pages/my-projects/index.vue?macro=true";
import { default as newHejcRTH6jgMeta } from "/builds/1tool/leckorter-portal/pages/my-projects/new.vue?macro=true";
import { default as _91id_93kwVffIOq8HMeta } from "/builds/1tool/leckorter-portal/pages/projects/[id].vue?macro=true";
import { default as indexekFoFvjWuGMeta } from "/builds/1tool/leckorter-portal/pages/projects/index.vue?macro=true";
export default [
  {
    name: "appointments",
    path: "/appointments",
    component: () => import("/builds/1tool/leckorter-portal/pages/appointments/index.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    component: () => import("/builds/1tool/leckorter-portal/pages/dashboard.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/builds/1tool/leckorter-portal/pages/index.vue")
  },
  {
    name: "invoices",
    path: "/invoices",
    component: () => import("/builds/1tool/leckorter-portal/pages/invoices/index.vue")
  },
  {
    name: "login-forgot-password",
    path: "/login/forgot-password",
    meta: forgot_45passwordEUFjyHtc1xMeta || {},
    component: () => import("/builds/1tool/leckorter-portal/pages/login/forgot-password.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexyQzNj8i3d3Meta || {},
    component: () => import("/builds/1tool/leckorter-portal/pages/login/index.vue")
  },
  {
    name: "login-magic-link",
    path: "/login/magic-link",
    meta: magic_45linkoajBhhxVj5Meta || {},
    component: () => import("/builds/1tool/leckorter-portal/pages/login/magic-link.vue")
  },
  {
    name: "my-projects",
    path: "/my-projects",
    component: () => import("/builds/1tool/leckorter-portal/pages/my-projects/index.vue")
  },
  {
    name: "my-projects-new",
    path: "/my-projects/new",
    component: () => import("/builds/1tool/leckorter-portal/pages/my-projects/new.vue")
  },
  {
    name: "projects-id",
    path: "/projects/:id()",
    component: () => import("/builds/1tool/leckorter-portal/pages/projects/[id].vue")
  },
  {
    name: "projects",
    path: "/projects",
    component: () => import("/builds/1tool/leckorter-portal/pages/projects/index.vue")
  }
]